jQuery(function($){

    let $glasprofielen = $('.glasprofielen');
    if ($glasprofielen.length == 0 || $(window).width() < 767){
        return;
    }

    let $cards = $glasprofielen.find('.glasprofielen__item');
    let cardHeight = $cards.outerHeight();
    let gap = 10; 

    // For speed reasons, only want the scroll event to fire when the section is actually in view
    let intersectTrigger = document.querySelector('.glasprofielen');  
    function handleIntersect(entries, observer) {
        entries.forEach(entry => {       
            if (entry.isIntersecting) {
                $(window).on('scroll.cards', function(e) {
                    let scrollTop = $(window).scrollTop();
                    let glasprofielenTop = $glasprofielen.offset().top;
                    
                    // Calculate the scroll position relative to the top of the section
                    let scrollPosition = scrollTop - glasprofielenTop;

                    $cards.each(function(index) {
                        let cardTopPosition = index * (cardHeight + gap);
                        
                        // Calculate the distance the user has scrolled into the card
                        let scrollIntoCard = scrollPosition - cardTopPosition;
                        
                        if (scrollIntoCard > 0 && scrollIntoCard < cardHeight) {
                            // Calculate scale value based on scroll position within the card
                            let scaleValue = 1 - (0.4 * (scrollIntoCard / cardHeight)); 
                            $(this).css('transform', 'scale(' + scaleValue + ')');
                        } else if (scrollIntoCard >= cardHeight) {
                            $(this).css('transform', 'scale(0.7)');
                        } else {
                            $(this).css('transform', 'scale(1)');
                        }
                    });
                });     
            }
            else {
                $(window).off('scroll.cards');
            }
        });
    }

    const observer = new IntersectionObserver(handleIntersect, {
        root: null, 
        threshold: 0.3 
    });

    observer.observe(intersectTrigger);
    
});
